export const mockData = {
    stats: {
      totalEarnings: 3247.80,
      activeReferrals: 76,
      monthlyRevenue: 432.50,
      availableForPayout: 2432.50,
      referralsByTier: {
        tier1: 50,  // At 20% commission
        tier2: 26,  // At 30% commission
        tier3: 0    // At 40% commission
      },
      currentTier: 2,
      // Chart data for last 6 months
      monthlySignups: [8, 12, 15, 18, 14, 9],     // Most recent month last
      annualSignups: [2, 4, 6, 8, 5, 3],          // Most recent month last
      monthlyPlanUses: [6, 10, 12, 15, 11, 7],    // Most recent month last
      annualPlanUses: [1, 3, 4, 6, 3, 2],         // Most recent month last
      earnings: {
        // Tier 1 maxes at 50 referrals
        tier1Earnings: [
          170.00, 170.00, 170.00, 170.00, 170.00, 170.00  // Fixed at max tier 1
        ],
        // Tier 2 grows as more referrals added (51-100)
        tier2Earnings: [
          132.60, 153.30, 178.50, 204.90, 229.50, 255.60
        ],
        // Tier 3 starts when over 100 referrals
        tier3Earnings: [0, 0, 0, 0, 0, 0]
      }
    },
    
    codes: [
      {
        id: 'code1',
        code: 'AFFILIATE15',
        type: 'percentage',
        value: 15,
        plans: ['monthly_plan'],
        currentUses: 45,
        maxUses: 1000,
        validUntil: new Date('2024-12-31'),
        active: true
      },
      {
        id: 'code2',
        code: 'AFFILIATE10',
        type: 'percentage',
        value: 10,
        plans: ['annual_plan'],
        currentUses: 31,
        maxUses: 1000,
        validUntil: new Date('2024-12-31'),
        active: true
      }
    ],
  
    payouts: [
      {
        id: 'payout1',
        amount: 432.50,
        status: 'pending',
        requestedAt: new Date('2024-01-03'),
        paypalEmail: 'affiliate@example.com',
        affiliateId: 'testAffiliateId1',
        month: 0, // January
        year: 2024,
        breakdown: {
          tier1Count: 45,
          tier2Count: 5,
          tier3Count: 0,
          totalReferrals: 50
        }
      },
      {
        id: 'payout2',
        amount: 385.20,
        status: 'paid',
        requestedAt: new Date('2023-12-01'),
        processedAt: new Date('2023-12-03'),
        processedBy: '4JkJV2u5InQeearkcPKfFkbC73s2',
        paypalEmail: 'affiliate@example.com',
        affiliateId: 'testAffiliateId1',
        month: 11, // December
        year: 2023,
        breakdown: {
          tier1Count: 42,
          tier2Count: 3,
          tier3Count: 0,
          totalReferrals: 45
        }
      },
      {
        id: 'payout3',
        amount: 430.10,
        status: 'denied',
        requestedAt: new Date('2023-11-01'),
        processedAt: new Date('2023-11-02'),
        processedBy: '4JkJV2u5InQeearkcPKfFkbC73s2',
        paypalEmail: 'affiliate@example.com',
        affiliateId: 'testAffiliateId1',
        month: 10, // November
        year: 2023,
        breakdown: {
          tier1Count: 40,
          tier2Count: 0,
          tier3Count: 0,
          totalReferrals: 40
        }
      }
    ]
  };